/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            fontSize: 'xs',
            marginTop: [2, 2, 3, 3, 3]
        },
        icon: {
            display: 'flex',
            boxSize: 4,
            color: 'grey.700'
        },
        link: {
            textDecoration: 'none',
            color: 'grey.700',
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center'
        },
        bcText: {
            lineHeight: '0',
            paddingTop: '0.25em',
            paddingBottom: '0.5em',
            '@supports (-webkit-appearance: none) and (stroke-color: transparent)': {
                paddingTop: '0.6em',
                paddingBottom: '0.20em'
            },
            // For macOS Chrome
            '.is-mac-chrome &': {
                paddingTop: '0.5em',
                paddingBottom: '0.35em'
            }
        },
        lastLink: {
            color: 'black'
        }
    },
    parts: ['container', 'icon', 'link', 'lastLink']
}
